// extracted by mini-css-extract-plugin
export default {"container":"DeclinedImagesList_container__FKCXX","deleteAllButton":"DeclinedImagesList_deleteAllButton__SLsW0","pagination":"DeclinedImagesList_pagination__N1cBP"};